/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Transcript_LabelInputs */

const en_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning transcript`)
};

const fr_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription du sous-titrage en direct`)
};

const de_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelungs-Transkript`)
};

const it_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione dei sottotitoli in diretta`)
};

const ru_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст субтитров в реальном времени`)
};

const es_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción con subtítulos en directo`)
};

const zh_cn2_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕文字稿`)
};

const ja_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプションの文字起こし`)
};

const hi_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग ट्रांसक्रिप्ट`)
};

const pt_pt2_live_caption_transcript_label = /** @type {(inputs: Live_Caption_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`transcrição da legenda ao vivo`)
};

/**
* | output |
* | --- |
* | "Live captioning transcript" |
*
* @param {Live_Caption_Transcript_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_transcript_label = /** @type {((inputs?: Live_Caption_Transcript_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Transcript_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_transcript_label(inputs)
	if (locale === "de") return de_live_caption_transcript_label(inputs)
	if (locale === "it") return it_live_caption_transcript_label(inputs)
	if (locale === "ru") return ru_live_caption_transcript_label(inputs)
	if (locale === "es") return es_live_caption_transcript_label(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_transcript_label(inputs)
	if (locale === "ja") return ja_live_caption_transcript_label(inputs)
	if (locale === "hi") return hi_live_caption_transcript_label(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_transcript_label(inputs)
	return en_live_caption_transcript_label(inputs)
});